/*
 * File: main.ts
 * File Created: 2023-11-27 03:21:15
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-11-20 06:11:01
 * Modified By: Val Liu
 * -----
 */

/// install style
import "./core/scss/style.scss";

import Vue from "vue";
import router from "@root/core/router";

/// directives //////////////////////////////
import "./core/directives";

/// tags ////////////////////////////////////
import "./core/tags";
/////////////////////////////////////////////

/// quicks //////////////////////////////////
import "./core/utilities/quick-helper";
/////////////////////////////////////////////

/// components //////////////////////////////
/// install core components
import "./components";
import "@/components";
/////////////////////////////////////////////

/// plugins /////////////////////////////////
/// install vuerx support
import VueRx from "@valuis0429/vue-rx";
Vue.use(VueRx);

/// install portal-vue support
import PortalVue from "portal-vue";
Vue.use(PortalVue);

/// install theme support
import { ThemePlugin } from "./core/private/plugins/theme";
Vue.use(ThemePlugin);

/// install global support //////////////////
import { GlobalPlugin } from "@/config/default/global";
Vue.use(GlobalPlugin);

/////////////////////////////////////////////
/// install language support
import { LangPlugin, lang } from "./core/i18n";
Vue.use(LangPlugin);

/// install form support
import { FormPlugin } from "./core/private/plugins/form";
Vue.use(FormPlugin);

/// install life cycle support
import { LifeCyclesPlugin } from "./core/private/plugins/life-cycles";
Vue.use(LifeCyclesPlugin);

/// install modal support
import { ModalPlugin } from "./core/private/plugins/modal";
Vue.use(ModalPlugin);

/// install alert support
import { AlertPlugin } from "./core/private/plugins/alert";
Vue.use(AlertPlugin);

/// install auth support
import { AuthPlugin } from "./core/private/plugins/authentication";
Vue.use(AuthPlugin);

/// install info support
import { InfoPlugin } from "./core/private/plugins/info";
Vue.use(InfoPlugin);

/// install bootstrap ui support
import BootstrapVue from "@valuis0429/bootstrap-vue";
import "@valuis0429/bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue as any);

/// install PrimeVue ui support
import PrimeVue from "primevue/config";
import "primevue/resources/themes/lara-light-blue/theme.css";
import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
Vue.use(PrimeVue);

/// install ElementUI support
//import Element from "element-ui";
//Vue.use(Element);
import { Row, Radio, InputNumber, Select, Option, Popover, Input } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
[Row, Radio, InputNumber, Select, Option, Popover, Input].forEach((component) => {
    Vue.component(component.name, component);
});

/// install flat-pickr ///////////////////////
import flatPickrComponent from "vue-flatpickr-component";
import flatPickr from "flatpickr";
import "flatpickr/dist/l10n";
// console.log(flatPickr_l10n);
import "flatpickr/dist/flatpickr.css";
// theme is optional
// try more themes at - https://flatpickr.js.org/themes/
import "flatpickr/dist/themes/airbnb.css";
Vue.component("flat-pickr", flatPickrComponent);
// subscribe for lang change
lang.getObservable().subscribe((language) => {
    language = language.replace("-", "_").toLowerCase();
    flatPickr.localize(flatPickr.l10ns[language]);
});
/////////////////////////////////////////////

/// install shells //////////////////////////
/// install modal response
import "@/../core/private/shells";
/////////////////////////////////////////////

import "@/main";
/// make sure `views` are imported for route
import "@/views";

/// load config
import MainApp from "@/../core/private/main-app/index.vue";
(async () => {
    new MainApp({
        router: await router,
    }).$mount("#app");
})();

import "@/scss/styles.scss";
